import { progressAnatomy as S } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as g, defineStyle as r } from "@chakra-ui/styled-system";
import { mode as o, generateStripe as l, getColor as f } from "@chakra-ui/theme-tools";
const { defineMultiStyleConfig: b, definePartsStyle: t } = g(S.keys), h = r((e) => {
  const { colorScheme: n, theme: s, isIndeterminate: a, hasStripe: c } = e, d = o(
    l(),
    l("1rem", "rgba(0,0,0,0.1)")
  )(e), i = o("".concat(n, ".500"), "".concat(n, ".200"))(e), m = "linear-gradient(\n    to right,\n    transparent 0%,\n    ".concat(f(s, i), " 50%,\n    transparent 100%\n  )");
  return {
    ...!a && c && d,
    ...a ? { bgImage: m } : { bgColor: i },
    borderRadius: "full"
  };
}), y = r({
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}), u = r((e) => ({
  bg: o("onSurface.layoutHelper", "whiteAlpha.300")(e),
  borderRadius: "full"
})), p = r((e) => ({
  transitionProperty: "common",
  transitionDuration: "slow",
  ...h(e)
})), k = t((e) => ({
  label: y,
  filledTrack: p(e),
  track: u(e)
})), C = {
  xs: t({
    track: { h: "1" }
  }),
  sm: t({
    track: { h: "2" }
  }),
  md: t({
    track: { h: "3" }
  }),
  lg: t({
    track: { h: "4" }
  })
}, P = b({
  sizes: C,
  baseStyle: k,
  defaultProps: {
    size: "sm",
    colorScheme: "caribbeanGreen"
  }
});
export {
  P as progressTheme
};
